module.exports = __webpack_public_path__ + "img/google-play.23efc839.png";